import { createContext, useContext, useSyncExternalStore } from 'react';

/** The single desktop/phone decision. At 1024px and wider the app uses the desktop layout. */
export const DESKTOP_QUERY = '(min-width: 1024px)';

export function useDesktopMediaQuery(): boolean {
  return useSyncExternalStore(
    (fn) => {
      const mql = window.matchMedia(DESKTOP_QUERY);
      mql.addEventListener('change', fn);
      return () => mql.removeEventListener('change', fn);
    },
    () => window.matchMedia(DESKTOP_QUERY).matches,
  );
}

export const LayoutContext = createContext<boolean>(true);

/** True on the desktop layout. Screens read this; only the app shell decides it. */
export function useIsDesktop(): boolean {
  return useContext(LayoutContext);
}
